var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['ai-badge', _vm.size]},[(_vm.icon)?_c('font-awesome-icon',{class:{ 'mr-1': _vm.text === 'Ask' },attrs:{"icon":['fas', 'sparkles']}}):_vm._e(),_c('div',{staticClass:"h-100 d-flex align-items-center"},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }